import React from 'react';
import { isEmpty } from 'lodash';
import { Section, SectionHeader, RelatedArticles } from 'components';

const LearnMore = ({ allArticles }) => (
  <>
    <Section color={'white'} additionalClass={'development-teams__learn-more'}>
      <SectionHeader
        size={'medium'}
        description={
          'Read our latest articles and explore the fascinating world of new advancements in technology and how it impacts the businesses around the world.'
        }
        fixed
      >
        Learn more
      </SectionHeader>
    </Section>
    {!isEmpty(allArticles) && (
      <RelatedArticles
        id={'development-teams-learn-more-articles'}
        related={allArticles.edges.map(edge => ({
          title: edge.node.frontmatter.title,
        }))}
        background={'white'}
        allArticles={allArticles}
        sectionTitle={false}
        fixed
      />
    )}
  </>
);

export default LearnMore;
